export const applyDisplayThemeToDocument = ({
  accessibilityOptions,
  resolvedDisplayTheme,
  target = typeof document !== 'undefined' ? document.body : null,
} = {}) => {
  if (!target || !resolvedDisplayTheme) return;

  target.dataset.theme = resolvedDisplayTheme.tName;
  target.dataset.accessibilityColorMode = accessibilityOptions?.colorMode || 'default';
};
